import styled from '@emotion/styled'

/**
 * An importable RadioButtonInput, used to create customized radio buttons.
 * For best results, make this the child of the RadioButtonContainer
 */
const RadioButtonInput = styled.input`
  /* Reset the default radio button styles */
  -webkit-appearance: none;
  appearance: none;
  background-color: #ffffff;
  margin: 0;
  font: inherit;
  display: flex;
  width: 20px;
  height: 20px;
  border: 1px solid #847f7b;
  border-radius: 50%;
  padding: 8px;

  /* Prevents radio from squeezing on small screens */
  flex-shrink: 0;

  /* Add a box shadow to the radio button based on checked state */
  box-shadow: inset 0px -2px 4px 1px #cccccc, inset 0px 0px 0px 0px #0077c3;
  color: currentColor;

  /* Animate the radio button on checked state */
  transition: all 0.4s cubic-bezier(0.25, -0.01, 0.03, 1.2);

  /* Customize the appearance of the radio button on checked state */
  &:checked {
    content: '';
    border-color: #312f2d;
    box-shadow: inset 0px 1px 2px 0px rgba(0, 0, 0, 0.5), inset 0px 0px 0px 4px #3651c9,
      0px 0px 0px 1px #ffffff, 0px 0px 8px 0px rgba(0, 0, 0, 0.5);
  }

  &:focus-visible {
    outline: 2px dotted blue;
    outline-offset: 2px;
  }

  &:hover {
    cursor: pointer;
  }
`

export default RadioButtonInput
